module.exports = __webpack_public_path__ + "img/tendring.f2eba4d3.jpg";